import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ReplaceUnderscore' })
export class ReplaceUnderscore implements PipeTransform {
  transform(value: string): string {
    const newStr = value.replace(/_/g, ' ');
    return newStr;
  }
}
